var core=module.exports={"version":"2.4.0"};"number"==typeof __e&&(__e=core);